export class Cookies {
  _analyticsCookieName = '';
  _cookiesSource: null | string = null;
  _cookies: null | Record<string, any> = [];

  constructor(analyticsCookieName = '', cookiesSource: string | null = null) {
    this._analyticsCookieName = analyticsCookieName;
    this._cookiesSource = cookiesSource;
    this._cookies = null;
  }

  cookieToObject(cookieName: string) {
    const _cookies = this.cookies;
    let _cookie = null;

    _cookie = _cookies[cookieName];
    if (!_cookie) {
      return null;
    }

    const _cookieValues: Record<string, any> = {};
    _cookie.split('&').forEach((part: string) => {
      const _keyVal = part.split('=');
      _cookieValues[_keyVal[0]] = _keyVal[1];
    });

    return _cookieValues;
  }

  cookieAsObject(cookieName: string) {
    const _cookies = this.cookies;
    const _cookie = _cookies && _cookies[cookieName];

    return (_cookie && JSON.parse(_cookie)) || {};
  }

  get cookiesSource() {
    if (this._cookiesSource === null) {
      this._cookiesSource = document.cookie;
    }
    return this._cookiesSource;
  }

  get cookies() {
    if (this._cookies === null) {
      this._cookies = {};
      for (const _cookie of this.cookiesSource.split('; ')) {
        const _equalsIndex = _cookie.indexOf('=');
        const _key = _cookie.substr(0, _equalsIndex);
        const _value = _cookie.substr(_equalsIndex + 1, _cookie.length);
        this._cookies[_key] = decodeURIComponent(_value);
      }
    }
    return this._cookies;
  }

  get analyticsCookie() {
    return this.cookieToObject(this._analyticsCookieName);
  }
}
